import { shallowRef, computed, onMounted, provide } from 'vue'
import { useRoute } from 'vue-router/composables'
import { get, buttonTransform } from '../utils/index'
import { BUTTONGROUP } from '../tokens/index'

export function useButtonPage(propsButtons) {
  const allButton = shallowRef(null)
  const getButtonByKey = (key) => {
    return computed(() => {
      if (Array.isArray(key)) return key
      if (!allButton.value || !key) return []
      return allButton.value.find((im) => im.code === key)?.children ?? []
    })
  }
  provide(BUTTONGROUP, { getButtonByKey })
  const route = useRoute()
  const getList = async () => {
    if (propsButtons) {
      allButton.value = buttonTransform(propsButtons)
    } else {
      const [resData] = await get('rest/ezcomp/navigator/getMenu', {
        lead: '0',
        component: route.name,
      })
      allButton.value = buttonTransform(resData?.data ?? [])
    }
  }
  onMounted(getList)

  return {
    getButtonByKey,
  }
}
